export default "__VITE_ASSET__e7723b6f__"